import BookingInfoCard from "containers/Company/EventBookingInfo/InfoCard/EventBookingContainer";
import useCurrentBookingSeason, { isBookingSeason } from "containers/Company/EventBooking/useCurrentBookingSeason";
import { NO_AVAILABLE_SEASON } from "containers/Company/EventBooking/interface";
import TitleUnderlined from "components/TitleUnderlined/TitleUnderlined";
import { Button, Col, Row } from "antd";
import { ArrowRightOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import { useViewport } from "@bindeleddet/core/hooks";
import { isCompanyUser, useLoginContext } from "@bindeleddet/core/contexts/login";

const EventBookingInfo = () => {
  const { width } = useViewport();
  const breakpoint = 900;
  const { currentUser } = useLoginContext();
  const season = useCurrentBookingSeason();

  const bookingStatus = () => {
    if (season === NO_AVAILABLE_SEASON) return "Mer informasjon om neste bookingsesong kommer snart.";
    if (!isBookingSeason(season)) return null;

    const semester = `${season.is_fall ? "høsten" : "våren"} ${season.year}`;
    if (season.is_open) return `Booking for bedriftspresentasjoner ${semester} er åpen.`;
    if (new Date(season.booking_end) < new Date()) {
      return `Bookingperioden for bedriftspresentasjoner ${semester} er over. Ønsker dere å booke en dato, send en e-post til bedrift@bindeleddet.no.`;
    }

    const openTime = new Intl.DateTimeFormat("no-NO", {
      weekday: "long",
      day: "numeric",
      month: "long",
      hour: "numeric",
      minute: "numeric",
    }).format(new Date(season.booking_open));
    return `Booking for bedriftspresentasjoner ${semester} åpner ${openTime}.`;
  };

  if (!isCompanyUser(currentUser)) {
    return (
      <div style={{ margin: "5%" }}>
        <TitleUnderlined title="Booking av arrangement" />
        <div style={{ padding: ".4em", marginTop: "1em" }}>
          Logg inn som bedrift for å se informasjon om booking og priser. Har dere spørsmål, ta kontakt på{" "}
          <a href="mailto:bedrift@bindeleddet.no">bedrift@bindeleddet.no</a>.
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        style={{
          margin: "5%",
        }}
      >
        <Row
          gutter={{
            xs: 8,
            sm: 16,
            md: 24,
          }}
        >
          <Col span={width < breakpoint ? 24 : 16}>
            <TitleUnderlined title="Booking av arrangement" />
          </Col>
          <Col
            span={width < breakpoint ? 24 : 8}
            style={
              width < breakpoint ? { textAlign: "left", marginTop: "2em", marginBottom: "2em" } : { textAlign: "right" }
            }
          >
            <Link to="/company/event-booking/booking/">
              <Button
                size="large"
                icon={<ArrowRightOutlined />}
                style={{ backgroundColor: "var(--secondary-color)", color: "var(--light)" }}
              >
                Gå til booking
              </Button>
            </Link>
          </Col>
        </Row>
        <div
          style={{
            padding: ".4em",
            marginTop: "1em",
          }}
        >
          {bookingStatus()}
          <br />
          Dersom du har spørsmål, eller din bedrift ønsker påminnelse per mail eller telefon, ta kontakt på{" "}
          <a href="mailto:bedrift@bindeleddet.no">bedrift@bindeleddet.no</a>.
        </div>
        <BookingInfoCard season={isBookingSeason(season) ? season : undefined} />
      </div>
    </>
  );
};

export default EventBookingInfo;
